module.exports = __webpack_public_path__ + "files/9d802d642272b207fb3352e16fcafc7d.png";